export default "__VITE_ASSET__CQg5y7iq__"